import MattressDA from '../mattress/MattressDA';

export default class SampleCollector {
  static _addTexture(texture, address, params, array = null) {
    if (!texture) {
      return array;
    }
    let arr = array;

    if (!arr) {
      arr = [];
    }
    let texID = null;

    if (typeof (texture) === 'string') {
      texID = texture;
    } else if (texture) {
      texID = texture.id;
    }

    if (typeof (texID) !== 'undefined' && texID !== null) {
      arr.push({sampleId: texID, sample: texture, address: address});
    }

    return arr;
  }

  static getSamplesByConfig(config, params = null, array = null) {
    if (!config) {
      return array;
    }
    let arr = array;

    const singles = config.singles;

    if (singles) {
      const numSingles = singles.length;

      for (let i = 0; i < numSingles; ++i) {
        arr = this._getSamplesBySingle(singles[i], {part: 'single', config: config, singleIndex: i}, params, arr);
      }
    }

    return arr;
  }

  static getSamplesBySingle(single, params = null, array = null) {
    return this._getSamplesBySingle(single, {part: 'single'}, params, array);
  }

  static _hasTexture(obj) {
    if (!obj) {
      return false;
    }
    if (!obj.texture) {
      return false;
    }
    const id = obj.texture.id;

    if (id === null) {
      return false;
    }
    const t = typeof (id);

    if (t === 'string' && id.length > 0) {
      return true;
    }
    if (t === 'number') {
      return true;
    }

    return false;
  }
  static _findTextureId(object) {
    if (!object) {
      return null;
    }
    if (!object.texture) {
      return null;
    }
    const id = object.texture.id;
    const t = typeof (id);

    if (t === 'string' || t === 'number') {
      return id;
    }

    return null;
  }

  static _getSamplesBySingle(single, address, params = null, array = null) {
    if (!single) {
      return array;
    }
    let arr = array;

    arr = this._getSamplesByTopOrBottom('top', single.top, single, {single: single, part: 'top', parent: address}, params, arr);
    arr = this._getSamplesByTopOrBottom('bottom', single.bottom, single, {single: single, part: 'bottom', parent: address}, params, arr);

    if (single.border) {
      arr = this._getSamplesByBorder(single.border, {single: single, part: 'border', parent: address}, params, arr);
    }

    arr = this._getSamplesBySingleHandles(single, {single: single, part: 'handles', parent: address}, params, arr);

    return arr;
  }

  static _getSamplesBySingleHandles(single, address, params, array) {
    const fabricSample = MattressDA.getHandleSample(single, 'fabric', null);
    const tapeSample = MattressDA.getHandleSample(single, 'tape', null);

    const tFabricSample = typeof (fabricSample);
    const tTapeSample = typeof (tapeSample);

    const validFabricSample = tFabricSample === 'string' || tFabricSample === 'number';
    const validTapeSample = tTapeSample === 'string' || tTapeSample === 'number';

    if (!validFabricSample && !validTapeSample) {
      return array;
    }
    let arr = array;

    if (validFabricSample) {
      arr = this._addTexture(fabricSample, {single: single, part: 'handles', subpart: 'fabric', parent: address}, params, arr);
    }
    if (validTapeSample) {
      arr = this._addTexture(tapeSample, {single: single, part: 'handles', subpart: 'tape', parent: address}, params, arr);
    }

    return arr;
  }

  static _getSamplesByTopOrBottom(name, topOrBottom, single, address, params = null, array = null) {
    let arr = array;

    if (this._hasTexture(topOrBottom)) {
      arr = this._addTexture(topOrBottom.texture, address, params, arr);
    } else if (this._hasTexture(single)) {
      arr = this._addTexture(single.texture, address, params, arr);
    }

    if (!topOrBottom) {
      return arr;
    }

    const mirrorPanel = topOrBottom.mirrorPanel;

    if (mirrorPanel) {
      const mpPartName = `${name}MirrorPanel`;

      arr = this._addTexture(mirrorPanel.texture, {part: mpPartName, parent: address, mirrorPanel: mirrorPanel}, params, arr);
    }

    return arr;
  }

  static _getSamplesByBorder(border, address, params, array) {
    if (!border) {
      return array;
    }

    return this._getSamplesByBorderComponents(border.components, address, params, array);
  }

  static _getSamplesByBorderComponents(borderComponents, address, params, array) {
    if (!borderComponents) {
      return array;
    }
    const num = borderComponents.length;

    if (!num) {
      return array;
    }
    let arr = array;

    for (let i = 0; i < num; ++i) {
      arr = this._getSamplesByBorderComponent(borderComponents[i], i, num, address, params, arr);
    }

    return arr;
  }

  static _getSamplesByBorderComponent(borderComponent, index, total, address, params, array) {
    if (!borderComponent) {
      return array;
    }
    let arr = array;

    let type = borderComponent.type;

    type = type ? type.toLowerCase() : type;

    if (type === 'fabric' || type === 'tape' || type === 'gusset') {
      arr = this._addTexture(borderComponent.texture, {parent: address, part: 'border', borderIndex: index, borderComponent: borderComponent}, params, arr);
    }

    return arr;
  }
}
